import { Component, OnInit, NgZone } from '@angular/core';
import { Observable, of, merge, Subject, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/core/api/services/alertservice/alert.service';
import { ViewrateService } from 'src/app/core/api/services/viewrate.service';

@Component({
  selector: 'app-dates',
  templateUrl: './dates.component.html',
  styleUrls: ['./dates.component.scss']
})
export class DatesComponent implements OnInit {
  //magazineId: any
  results: any[];
  assetTypeId: number[];
  showDates: boolean;
  //alertService: AlertService;
  selectedMagazineId: number;
  constructor(private _ViewrateService: ViewrateService) {
    this.assetTypeId = [8,9]
  }


  ngOnInit() {
    this._ViewrateService.assetsList.subscribe((response: any) => {
      this.results = response;
    });
    }

   

  hasDates() {
    if(this.results){
     return this.results.find((result) => (this.assetTypeId.indexOf(result.assetTypeId) != -1) ? true : false);
    }
  }

  onMedialinkClick(MediaKitURL) {
    window.close();
    let w = window.open(MediaKitURL, "MediaKitPopup", "height=600,width=800");
    w.focus();
  }

}
